import { IconButton, Tooltip } from "@mui/material";
import preview from "./icons/preview.svg";
import move from "./icons/move.svg";
import locked from "./icons/locked.svg";
import { IDraggableAlignmentResultSection, IResource, ResourceType } from "store/types";
import { ResourcePreview } from "./ResourcePreview";
import { useState } from "react";
import { ResourceMoveMenu } from "./ResourceMoveMenu";
import { DraggableLocation } from "@hello-pangea/dnd";

interface IProps {
  section: IDraggableAlignmentResultSection;
  resource: IResource;
  onMove: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExclude?: (source: DraggableLocation, draggableId: string[]) => any;
  state: any;
}

export const ResourceButtons = ({ section, resource, onMove, onExclude, state }: IProps) => {
  const [openPreview, setOpenPreview] = useState(false);
  const onPreviewClicked = () => setOpenPreview(true);
  const handleClosePreview = () => setOpenPreview(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const onMoveMenuClicked = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleCloseMoveMenu = () => setAnchorEl(null);

  const canPreview = new Set([
    ResourceType.URL,
    ResourceType.PAGE,
    ResourceType.FORUM,
    ResourceType.QUIZ,
    ResourceType.LTI,
    ResourceType.RESOURCE,
    ResourceType.ASSIGNMENT,
    ResourceType.VIDEO,
    ResourceType.IMAGE,
    ResourceType.LABEL,
    ResourceType.FEEDBACK,
  ]);
  const previewDisabled = !canPreview.has(resource.type);

  return (
    <>
      {previewDisabled && (
        <Tooltip title="Cannot be previewed" placement="bottom">
          <span>
            <IconButton disabled>
              <img src={preview} alt="preview" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {previewDisabled || (
        <Tooltip title="Preview" placement="bottom">
          <IconButton onClick={onPreviewClicked}>
            <img src={preview} alt="preview" />
          </IconButton>
        </Tooltip>
      )}
      {resource.readOnly && (
        <Tooltip title="Cannot be moved" placement="bottom">
          <span>
            <IconButton disabled>
              <img src={locked} alt="locked" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {resource.readOnly || (
        <Tooltip title="Move to" placement="bottom">
          <IconButton aria-owns={anchorEl ? "move-menu" : undefined} aria-haspopup="true" onClick={onMoveMenuClicked}>
            <img src={move} alt="move" />
          </IconButton>
        </Tooltip>
      )}

      <ResourceMoveMenu
        state={state}
        anchor={anchorEl}
        onClose={handleCloseMoveMenu}
        onMove={onMove}
        onExclude={onExclude}
        resource={resource}
        section={section}
      />
      <ResourcePreview resource={resource} open={openPreview} onClose={handleClosePreview} />
    </>
  );
};
